<template>
    <div class="order-item">
        <b-icon v-if="order.closedPercentage === 1 || order.closedPercentage === 0" :icon="orderIcon"  :style="{ color: orderColor }" class="order-icon"></b-icon>
		<div v-if="order.closedPercentage > 0 && order.closedPercentage < 1" class="radial-progress" :style="{ '--progress': order.closedPercentage * 100 + '%' }"></div>
        <span class="order-details">
            <a :href="`#/order-detail/${order.orderId}`">{{ order.orderName }}</a> - {{ order.client }}
            <span v-if="rollupFlags.length" class="order-flags-inline">
                <b-icon v-for="flag in rollupFlags" :key="flag" :icon="flag" custom-size="mdi-24px" :style="{ color: flagColor(flag) }"></b-icon>
            </span>
            <span class="order-rows-summary">
                ({{ order.openCount }} open, {{ order.closedCount }} closed, {{ Math.round(order.closedPercentage * 100) }}% completed)
            </span>
        </span>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { getOrderCompletionState, rollupSpecialFlags, SPECIAL_FLAG_COLORS } from "@/lib/HelperFns";

    export default defineComponent({
        name: 'OrderInList',
        props: {
            order: {
                type: Object,
                required: true,
            },
        },
        methods: {
            flagColor(flag) {
                return SPECIAL_FLAG_COLORS[flag];
            },
        },
        computed: {
            rollupFlags() {
                return rollupSpecialFlags(this.order);
            },
            orderCompletionState() {
                return getOrderCompletionState(this.order);
            },
            orderIcon() {
                switch (this.orderCompletionState) {
                    case 'completed':
                        return 'check';
                    case 'partial':
                        return 'timer-sand';
                    default:
                        return 'close';
                }
            },
            orderColor() {
                switch (this.orderCompletionState) {
                    case 'completed':
                        return '#48c774';
                    case 'partial':
                        return '#646464';
                    default:
                        return '#ff3860';
                }
            },
        },
    })
</script>

<style scoped>
.order-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
}

.order-icon {
    margin-right: 0.75rem;
}

.order-details strong {
    color: #3273dc;
}

.order-rows-summary {
    font-size: 0.9rem;
    color: #7a7a7a;
    margin-left: 0.5rem;
}

.order-flags-inline {
    margin-left: 0.4rem;
    white-space: nowrap;
}

.order-flags-inline .icon {
    vertical-align: middle;
}
</style>
